angular.module('natgeo').controller('Level4PlanSonarScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 
function Level4PlanSonarScreen($scope, element, ScreenFactory, manager, container)
{
	var screen = ScreenFactory( 'level4_plan_sonar', element );
	
	screen.once('introBefore', function()
	{
		anim8.save('level4PlanSonarIntro', {
			keyframe: {
				from: {
					scale: 0
				},
				to: {
					scale: 1
				}
			},
			initial: {
				origin: 'left bottom'
			}
		});

		anim8.save('level4PlanSonarRotate', {
			keyframe: {
				from: {
					rotate: 0
				},
				to: {
					rotate: 360
				}
			},
			initial: {
				origin: 'left bottom'
			}
		}, {
			easing: 'linear'
		});

		anim8.save('level4PlanRobotMove', {
			keyframe: {
				'0': {
					translateY: 0
				},
				'90': {
					translateY: -500,
					opacity: 1
				},
				'100': {
					translateY: -510,
					opacity: 0
				}
			},
			units: {
				translateY: '%'
			}
		}, {
			easing: 'linear'
		});

		anim8.save('level4PlanRobotOutro', {
			keyframe: {
				from: {
					opacity: true
				},
				to: {
					opacity: 0
				}
			}
		});

	});

	var outroRobots = false;

	screen.on('outroBefore', function()
	{
		outroRobots = screen._robots.isAnimating();
	});

	screen.on('outroBegin', function()
	{
		if ( outroRobots )
		{
			screen._robots.play('level4PlanRobotOutro');
		}
	});
	
	// The next screen is the build screen
	$scope.next = function()
	{
		manager.transition('level4_build_body');
	};
	
	// The previous screen is the learn screen
	$scope.prev = function()
	{
		manager.transition('level4_plan');
	};
	
}]);